import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import { decodeId } from "../../../../../../utils/hash";
import { useParams } from "react-router-dom";
import EADetailsCard from "../../components/EADetailsCard";
import Pagination from "../../../../../../components/Pagination";
import { EAsData } from "../../../../network/api/EAsData";
import EditEAForm from "../../components/EditEAForm";

export default function ManageEAs() {
    const { setPageTitle, setPageUserID } = useAppContext();
    const { id: ownerID } = useParams();
    const ownerId = decodeId(ownerID);

    const [eALoading, setEALoading] = useState(false);
    const [eAErrorMessage, setEAErrorMessage] = useState(null);

    const [eAList, setEAList] = useState([]);
    const [reload, setRelead] = useState(null);
    const [activeFilters, setActiveFilters] = useState(["all"]);


    const [pageFilters, setPageFilters] = useState({
        page: null,
        name: null,
        description: null,
        secret_code: null,
        in_store: null,
    });

    const [pageProps, setPageProps] = useState({
        page: 1,
        totalPages: 1,
        totalEntries: 0,
        entryLimit: 0,
        visiblePages: [],
    });

    const handleFilters = (e) => {
        e.preventDefault();
        const { name } = e.target;
        setActiveFilters([name]);

        if (name === "all") {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                in_store: null
            }));
        } else if (name === "in_store") {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                in_store: 1
            }));
        }
    }


    const handleSerchChange = (e) => {
        e.preventDefault();
        const { value } = e.target;

        if (value.length >= 3) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                name: value,
                description: value,
                secret_code: value,
            }));
        }

        if (value.length === 0) {
            setPageFilters((prev) => ({
                ...prev,
                page: null,
                name: null,
                description: null,
                secret_code: null,
            }));
        }

    }

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pageProps.totalPages) {

            setPageProps((prev) => ({
                ...prev,
                page: page,
            }));
            setPageFilters((prev) => ({
                ...prev,
                page: page,
            }));
        }


    };



    useEffect(() => {
        const fetchEAs = async () => {
            setEALoading(true);
            setEAErrorMessage(null);

            try {
                const response = await EAsData({ pageFilters: pageFilters, ownerId: ownerId });

                if (response.status === "success") {

                    if (JSON.stringify(response.data.data) !== JSON.stringify(eAList)) {
                        setEAList(response.data.data);

                        setPageProps({
                            page: response.data.page,
                            totalPages: response.data.total_pages,
                            totalEntries: response.data.total_records,
                            entryLimit: response.data.limit,
                            visiblePages: response.data.visible_pages,
                        })
                    }

                } else {
                    setEAErrorMessage({ sTatus: response.status, message: response.message });
                }
            } catch (err) {
                setEAErrorMessage({ sTatus: "error", message: err.message || "Failed to load eas." });
            } finally {
                setEALoading(false);
            }
        };
        setPageUserID(ownerId);
        fetchEAs();
    }, [pageFilters, ownerId, reload, eAList, setPageUserID]);

    useEffect(() => {
        setPageTitle("Manage EAs");
        return;
    }, [setPageTitle]);
    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="d-flex mb-4 justify-content-between align-items-center flex-wrap">
                                <div className="card-tabs mt-3 mt-sm-0 mb-xxl-0 mb-4">
                                    <ul className="nav nav-tabs" role="tablist">
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeFilters.includes("all") ? "active" : ""} `}
                                                onClick={handleFilters}
                                                name="all"
                                            >
                                                All EAs ({pageProps.totalEntries})
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeFilters.includes("in_store") ? "active" : ""}`}
                                                onClick={handleFilters}
                                                name="in_store"
                                            >
                                                In Store
                                            </button>
                                        </li>


                                    </ul>
                                </div>
                                <div className="table-search">
                                    <div className="input-group search-area mb-xxl-0 mb-4">
                                        <input type="text" className="form-control" placeholder="Search here" onChange={handleSerchChange} />
                                        <span className="input-group-text"><i className="flaticon-381-search-2"></i></span>
                                    </div>
                                </div>
                                <button className="btn btn-primary mb-xxl-0 mb-4 radius-btn" data-bs-toggle="modal" data-bs-target="#editEAModal"><i className="fa-solid fa-plus me-2"></i>New EA</button>
                            </div>

                            <div className=" ">
                                <div id="guestTable-all-1_wrapper" className="dataTables_wrapper no-footer ">
                                    <div className="row">
                                        {
                                            eAList.map((ea, index) => (

                                                <div key={index} className="col-xl-4 col-lg-12 col-sm-12">
                                                    <EADetailsCard eaId={ea?.id} expert={ea} showFooterStats={false} showImage={true} showGButton={true}/>
                                                </div>
                                            ))
                                        }
                                        {eALoading ? (
                                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75">
                                                <div className="spinner-border text-primary" role="status"></div>
                                            </div>
                                        ) :
                                            <></>}
                                    </div>



                                    {eAList.length === 0 && !eALoading ?
                                        <div className="d-flex flex-column justify-content-center align-items-center py-5">
                                            <i className={`fa ${eAErrorMessage ? "fa-ban":"fa-folder-open"} text-muted mb-3`} style={{ fontSize: "4rem" }}></i>
                                            <h3 className="text-muted">{eAErrorMessage ? eAErrorMessage.message: "No EA Found"}</h3>
                                        </div> : <></>}
                                    <Pagination
                                        pageProps={pageProps}
                                        onPageChange={handlePageChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="modal fade" id="editEAModal" tabIndex="-1" aria-labelledby="editEAModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg ">
                    <div className="modal-content rounded-3 shadow">
                        <div className="modal-header border-0">
                            <h5 className="modal-title fw-semibold" id="exampleModalLabel">Add New Expert Advisor </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="card-body">
                            <EditEAForm method="POST" setExpert={setRelead} ownerId={ownerId}/>
                        </div>
                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}